export const apiUrl = process.env.API_URL || "https://coffeegram-server.herokuapp.com";
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
